var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warn-band",attrs:{"dir":"rtl","role":"status","aria-live":"polite"}},[_c('i',{staticClass:"fas fa-exclamation-triangle",attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"txt"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }